import { render, staticRenderFns } from "./loding.vue?vue&type=template&id=0b2f26ec&scoped=true"
import script from "./loding.vue?vue&type=script&lang=js"
export * from "./loding.vue?vue&type=script&lang=js"
import style0 from "./loding.vue?vue&type=style&index=0&id=0b2f26ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f26ec",
  null
  
)

export default component.exports